// Entry point — this is the file Vite bundles into dist/widget.js (architecture.md §4.2).
import { defineAdPolicyCheckerElement, TAG_NAME } from "./AdPolicyCheckerElement.js";

// architecture.md §4.2: reserves space for the element before it upgrades, so the widget
// loading doesn't itself cause the exact layout shift this product measures on other pages.
function injectProgressiveEnhancementStyle(): void {
  if (document.getElementById("apc-pre-upgrade-style")) return;
  const style = document.createElement("style");
  style.id = "apc-pre-upgrade-style";
  style.textContent = `${TAG_NAME}:not(:defined) { display: block; min-height: 420px; }`;
  document.head.appendChild(style);
}

injectProgressiveEnhancementStyle();
defineAdPolicyCheckerElement();
